<script setup lang="ts">
import './assets/style.scss'
import { ref } from 'vue'
import { useHelpers } from '@/shared/lib'
import { useSchedule } from '@/entities/Schedule'
import { VPreloader } from '@/shared/ui'
import ProgramCabinetItem from './ProgramCabinetItem.vue'

const { monthsList } = useHelpers()
const schedule = useSchedule()

const currentMonth = ref<number>(1)

const removeHandler = (month: number, day: number) => {
  delete schedule.list[month][day]
}
</script>

<template>
  <div class="schedule-program__control">
    <slot name="control" />

    <div class="schedule-program__filter">
      <VSelect
        :items="monthsList()"
        :label="$t('itf.programs_show')"
        v-model="currentMonth"
        hide-details
      />
    </div>
  </div>

  <VPreloader :wrapper-height="300" v-if="!schedule.data" />

  <template v-else v-for="(_, month) in schedule.list">
    <div class="schedule-program__list" v-if="currentMonth == month">
      <template v-for="(_, day) in schedule.list[month]">
        <ProgramCabinetItem
          v-model="schedule.list[month][day]"
          :month="month"
          :day="day"
          :outputs="schedule.data.output_count"
          @remove="removeHandler(month, day)"
        />
      </template>
    </div>
  </template>
</template>
